export const CHECKOUT_URL = 'https://running-coach-pro.impultienda.ar/checkout'

export const PRICING_ANCHOR = '#pricing'

export const BOX_IMG =
  'https://cdn.magicpatterns.com/uploads/vVca9ommJQbT7JEPnx8y3d/ChatGPT-Image-28-jul-2026_-06_10_00-p.m..webp'

export const PRODUCT_NAME = 'RUNNING COACH PRO™'
